import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CriminalRecordStatuteBatchRow } from '../../models/batch-row';

@Component({
  selector: 'app-charge-ops-modal',
  templateUrl: './charge-ops-modal.component.html',
  styleUrls: ['./charge-ops-modal.component.less']
})
export class ChargeOpsModalComponent implements OnInit {
@Input() chrg : CriminalRecordStatuteBatchRow;
  constructor(public modalService: NgbModal, public toast: ToastrService){}
  ngOnInit(): void {
    // console.info(this.pkg)
  }
}
